import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import PermissionGate from '../ReusableComponents/PermissionGate';
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit, MdPlaylistAdd } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import ModalProcessosLote from "./ModalProcessosLote";



const Processo = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_processos, setLoadingProcessos] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [processos, setProcessos] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { faculdade_id, faculdade_name } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [processo_id, setProcessoId] = useState(null);


    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [showModalLote, setShowModalLote] = useState(false);
    let refs = [];
    const dispatch = useDispatch();

    const user = useSelector(state=>state.AppReducer.user);

    const GetProcessos = async (page, search) => {

        let response = await Request.Get(`faculdade/get_processos/${faculdade_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {

            setProcessos(response.processos);

            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingProcessos(false);


        }
    }

    const DeleteProcesso = async (processo_id) => {

        let response = await Request.Delete(`faculdade/delete_processo/${processo_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        GetProcessos(pagination.current_page, search_oficial);



    }

    useEffect(() => {
        GetProcessos(1, search_oficial);
    }, []);

    let pesquisarTimeout = null;
    const history = useHistory();
    return (
        <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>


                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search placeholder={"Pesquisar pelo nome "+((user.empresa==null || user.empresa.change_text==false)?'do processo':'da vaga/cargo')} ValueChange={value => {
                            clearTimeout(pesquisarTimeout);
                            setSearchOficial(value);

                            pesquisarTimeout = setTimeout(() => {
                                let page = { ...pagination };
                                page.current_page = 1;
                                setPagination(pagination);
                                setLoadingProcessos(true);

                                GetProcessos(1, value)

                            }, 500);
                        }} />


{(user.role=='region_admin' || (user.empresa==null || user.empresa.can_add)) && <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                        <PermissionGate module="processo_seletivo" action="create"><Button variant="primary" className="flex align-center jcc processo-lote-open-btn" onClick={() => setShowModalLote(true)}>
                            <MdPlaylistAdd style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar {(user.empresa==null || user.empresa.change_text==false)?'processo':'vaga/cargo'} em lote</p>
                        </Button></PermissionGate>
                        <PermissionGate module="processo_seletivo" action="create"><Link to={{
                            pathname: "/processos/register/" + faculdade_id,
                            // state: {
                            //     course_id: id
                            // }
                        }} style={{ textDecoration: "none" }}>
                            <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar {(user.empresa==null || user.empresa.change_text==false)?'processo':'vaga/cargo'}</p></Button>
                        </Link></PermissionGate>
                    </div>}
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <ResponsiveTable id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Nome</th>
                                        <th>Data de início</th>
                                        <th>Data de encerramento</th>

                                        <th className="hidethis" data-priority="3">Ações</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_processos == false && processos.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.name}</td>
                                            <td>{moment(item.inicio).format('DD/MM/YYYY HH:mm')}</td>
                                            <td>{moment(item.fim).format('DD/MM/YYYY HH:mm')}</td>
                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td className="hidethis">
                                                <Link to={`/processos/show/${item.id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span
                                                        onClick={() => {

                                                        }}
                                                        className="inline-flex align-center jcc bg-warning icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                        title="Gerenciar processo"
                                                    >
                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </Link>
                                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_edit)) && <PermissionGate module="processo_seletivo" action="edit"><Link to={`/processos/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                                                        className="inline-flex align-center jcc bg-info icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                                        data-toggle="tooltip"
                                                        title="Editar questão"
                                                    >
                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link></PermissionGate>}
                                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_exclude)) && <PermissionGate module="processo_seletivo" action="delete"><span
                                                    onClick={(e) => {
                                                        setProcessoId(item.id);
                                                        setShowWarning(true);
                                                        e.stopPropagation();
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Deletar processo"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span></PermissionGate>}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </ResponsiveTable>
                            {loading_processos == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_processos == false && processos.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum processo encontrado</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide" : "") + " hidethis"}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingProcessos(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            GetProcessos(value, search_oficial)
                        }}
                    />

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingProcessos(true);
                        DeleteProcesso(processo_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo apagar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao deletar este processo, ele não estará mais disponível no sistema
                </SweetAlert>

                <ModalProcessosLote
                    showModal={showModalLote}
                    setShowModal={setShowModalLote}
                    faculdadeId={faculdade_id}
                    changeText={user.empresa != null && user.empresa.change_text == true}
                    empresa={user.empresa}
                    onFinish={() => GetProcessos(pagination.current_page, search_oficial)}
                />


            </div>

        </div>
    )
}

export default Processo;
